
import {Http, AxHttpControl} from './http';

type Callbacks = {
    success:Function
    fail?:Function
    finally?: Function
};

type ProResponse = {

    succ: Number
    code: Number
    error: String
    result: any
}

class SimResponse {
    protected promise;
    constructor(pro) {
        this.promise = pro;
    }
    public getResult() {
        let ret = {};
        this.promise.then((res) => {
            ret = res.result;
        });
        return ret;
    }
}

export class ServerApi {

    protected static http:Http;
    protected static baseUrl = '/server/api-v1.0/';

    protected static getHttp() {
        if (!this.http) {
            this.http  = new Http();
            // let baseUrl     = '/server/api-v1.0/';
            let baseUrl     = this.baseUrl;
            this.http.setBaseUrl(baseUrl);
        }
        return  this.http;
    }

    public static getServerUrl(uri) {
        let baseUrl     = this.baseUrl;
        return  `${baseUrl}${uri}`;
    }

    protected static makeDefaults(cbs) {
        if (!cbs) {
            cbs     = {};
        }
        if (!cbs.success) {
            cbs.success = function (data) {
                // console.log(['Allocate default success handler', data]);
                // Promise.resolve(data);
            }
        }
        if (!cbs.fail) {
            cbs.fail = function (err) {
                // console.log(['Allocate default fail handler', err]);
                // throw err;
            }
        }
        if (!cbs.finally) {
            cbs.finally = function (data) {
                // console.log(['Allocate default finally handler', data]);
            }
        }
        return  cbs;
    }

    protected static defaultThen(res) {
        return  res;
    }

    public static async syncPost(uri:string, data:object) : Promise<ProResponse> {
        let url:string  = this.getHttp().getBaseUrl() + uri;
        // return await Http.getHandler().post(url, data);
        let ret = {succ: 0, code: 0, error: 'undefined errors', result: {},message:'undefined errors',data:{}};
        let _url = this.baseUrl + uri;
        AxHttpControl.setUsing(_url, true);
        try {
            let syncResponse = await Http.getHandler().post(url, data);
            // return syncResponse;
            // if (syncResponse && syncResponse.data && syncResponse.data.result) {
            if (syncResponse && syncResponse.data) {
                ret.succ    = syncResponse.data.succ;
                ret.code    = syncResponse.data.code;
                ret.error   = syncResponse.data.error?syncResponse.data.error:syncResponse.data.message;
                ret.result  = syncResponse.data.result?syncResponse.data.result:syncResponse.data.data;
                ret.message  = syncResponse.data.message;
                ret.data  = syncResponse.data.data?syncResponse.data.data:'';
                syncResponse.data.result.succ = 1;
                console.log(ret)
                return  ret;
            } else {
                // return  {succ: 1};
                throw syncResponse.data.error || 'undefined errors';
            }
            // return syncResponse['result'] || {};
        } catch (exp) {
            // console.log(['iw-exp', exp]);
            // ret.error = exp;

        } finally {
            // console.log(['iw-final']);
        }
        AxHttpControl.setUsing(_url, false);
        return ret;
        // let obj = new SimResponse(res);
        // return obj;
    }

    //get请求
    public static async asyncGet(uri:string, data:object, opts?:any) {
        let syncResponse;
        let url:string  = this.getHttp().getBaseUrl() + uri;
        let ret = {succ: 0, code: 0, error: 'undefined errors', result: {}};
        let _url = this.baseUrl + uri;
        AxHttpControl.setUsing(_url, true);
        try {
            syncResponse = await Http.getHandler().get(url, {
                params: data,
                  ...opts
            });
            if (syncResponse && syncResponse.data) {
                ret.succ = syncResponse.data.succ;
                ret.code = syncResponse.data.code;
                ret.error = syncResponse.data.error;
                ret.result = syncResponse.data.result;
                return syncResponse.data;
            } else if (opts && opts.responseType === 'blob') {
                ret.succ = 1;
                ret.code = 0;
                ret.error = '';
                ret.result = {blob: syncResponse.data};
            } else {
                throw syncResponse.data.error || 'undefined errors';
            }
        } catch (exp) {
            ret.error = exp;
        }
        AxHttpControl.setUsing(_url, false);
        return ret;
    }

    //上传图片请求:请求链接保持原样
    public static async syncImgPost(uri:string, data:object, isBlob:Boolean) : Promise<ProResponse> {
        let ret = {succ: 0, code: 0, error: 'undefined errors', result: {}};
        let _url = this.baseUrl + uri;
        try {
            let syncResponse;
            if(isBlob){
                syncResponse = await Http.getHandler().post(_url, data, {responseType: 'blob'})
            }else{
                syncResponse = await Http.getHandler().post(_url, data)
            }
            if(isBlob){//下载
                ret.succ    = 1;
                ret.result  = syncResponse;
                return  ret;
            }else if (syncResponse && syncResponse.data) {
                ret.succ    = syncResponse.status;
                ret.result  = syncResponse.data;
                return  syncResponse.data;
            } else {
                throw '返回参数有误：'+JSON.stringify(syncResponse);
            }
        } catch (exp) {
            ret.error = exp;
        } finally {
            // console.log(['iw-final']);
        }
        return ret;
    }
    public static async asyncTestGet(uri:string, data:object, opts?:any) {
        let syncResponse;
        let url:string  =  uri;
        let ret = {succ: 0, code: 0, error: 'undefined errors', result: {}};
        let _url =  uri;
        AxHttpControl.setUsing(_url, true);
        try {
            syncResponse = await Http.getHandler().get(url, {
                params: data,
                  ...opts
            });
            if (syncResponse && syncResponse.data && syncResponse.data.result) {
                ret.succ = syncResponse.data.succ;
                ret.code = syncResponse.data.code;
                ret.error = syncResponse.data.error;
                ret.result = syncResponse.data.result;
                return syncResponse.data;
            } else if (opts && opts.responseType === 'blob') {
                ret.succ = 1;
                ret.code = 0;
                ret.error = '';
                ret.result = {blob: syncResponse.data};
            } else {
                throw syncResponse.data.error || 'undefined errors';
            }
        } catch (exp) {
            ret.error = exp;
        }
        AxHttpControl.setUsing(_url, false);
        return ret;
    }
     //下载文件模板
     public static async downFileTemplate(uri:string) : Promise<ProResponse> {
        let ret = {succ: 0, code: 0, error: 'undefined errors', result: {}};
        let _url = this.baseUrl + uri;
        try {
            let syncResponse = await Http.getHandler().get(_url,{responseType: 'blob'});
            ret.succ    = 1;
            ret.result  = syncResponse;
            return  ret;
        } catch (exp) {
            ret.error = exp;
        } finally {
            // console.log(['iw-final']);
        }
        return ret;
    }
}
